export const getCurrentHost = () => window.location.host;

export const getCurrentDomain = () => getCurrentHost().split('.').splice(-2).join('.');
